// staffs/teacher/data_teacher
import { getData } from 'src/services/RestApi';
import { formatPhone, formatCode } from 'src/utils/formatters';

export const getMyList = async (
  payload, {},
  onEndPoint = () => {},
  onSuccess = () => {},
  onError = () => {},
) => {
  const endPoint = 'api/teacher/list';
  onEndPoint(endPoint);

  const { result, error } = await getData(endPoint, payload);
  if (error) return onError(error);
  
  const hasGroup = payload?.keyword?.group?.trim();
  result.forEach((element) => {
    element.phone = formatPhone(element.phone);
    element.options = hasGroup ? '' : element.groupName;
    element.statusColor = (element.status === 0) ? 'warning.main' : 'inherit';
  });
  return onSuccess(result);
};

export const getMyItem = async (payload) => {
  const teacherId = Number(payload?.id) || 0;
  if (teacherId === 0) return {};

  const endPoint = 'api/teacher/detail';
  const { result, error } = await getData(endPoint, { teacherId: payload.id });

  if(error) return {};
  
  return result;
};

export const apiUpdate = async (payload) => {
  const endPoint = 'api/teacher/edit/carAssign';
  const { result, error } = await getData(endPoint, { teacherId: payload.id });
  return {result, error};
};


export const apiRemove = async (payload) => {
  const endPoint = 'api/teacher/edit/block';
  const { result, error } = await getData(endPoint, { teacherId: payload.id });
  return {result, error};
};